import React, {Component} from 'react';
import InnerPage from '../../shared/InnerPage/InnerPage'
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import DifferentialAdvantage from '../../components/DifferentialAdvantage/DifferentialAdvantage';
import { createDifferentialAdvantage, getDifferentialAdvantage, editDifferentialAdvantage } from '../../store/actions/differentialAdvantageActions';
import { getCompete, getCustomerSegment, getBenefits, getCompetitorsGroups, getChallengeStatements } from '../../store/actions/abilityToCompete';
import {getBenefitsLadder} from '../../store/actions/benefitsLadderActions';

class DifferentialAdvantageContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
      };
    }
    elementInfiniteLoad() {
      return (
        <div className='col-sm-12'>
          <div className='spinner3'>
            <div className='rect1'/>
            <div className='rect2'/>
            <div className='rect3'/>
            <div className='rect4'/>
            <div className='rect5'/>
          </div>
        </div>
      );
    }

    render() {
        return (
          <div>
            <InnerPage
              changeUserPassword={this.props.changeUserPassword}
              changePasswordResult={this.props.changePasswordResult}
              location={this.props.location.pathname.split('/')[this.props.location.pathname.split('/').length - 2]}
            >
                <DifferentialAdvantage
                  projectId={this.props.location.pathname.split('/')[this.props.location.pathname.split('/').length - 1]}
                  createDifferentialAdvantage={this.props.createDifferentialAdvantage}
                  editDifferentialAdvantage={this.props.editDifferentialAdvantage}
                  getDifferentialAdvantage={this.props.getDifferentialAdvantage}
                  differentialAdvantageData={this.props.differentialAdvantageData}
                  getCompete={this.props.getCompete}
                  compete={this.props.compete}
                  getCustomerSegment={this.props.getCustomerSegment}
                  getBenefits={this.props.getBenefits}
                  getCompetitorsGroups={this.props.getCompetitorsGroups}
                  getChallengeStatements={this.props.getChallengeStatements}
                  challengeStatement={this.props.challengeStatement}
                  getBenefitsLadder={this.props.getBenefitsLadder}
                  benefits={this.props.benefits}
                />
            </InnerPage>
            
          </div>
        )
    }
}

const mapStateToProps = (store, verify) => {
  return {
    differentialAdvantageData: store.differentialAdvantage,
    compete: store.compete,
    challengeStatement: store.challengeStatement,
    benefits: store.benefits,
  }
};

const mapDispatchToProps = (dispatch) => ({
  getDifferentialAdvantage: (body) => (dispatch(getDifferentialAdvantage(body))),
  createDifferentialAdvantage: (body) => (dispatch(createDifferentialAdvantage(body))),
  editDifferentialAdvantage: (body) => (dispatch(editDifferentialAdvantage(body))),
  getCompete: (body) => (dispatch(getCompete(body))),
  getCustomerSegment: (body) => (dispatch(getCustomerSegment(body))),
  getBenefits: (body) => (dispatch(getBenefits(body))),
  getCompetitorsGroups: (body) => (dispatch(getCompetitorsGroups(body))),
  getChallengeStatements: (body) => (dispatch(getChallengeStatements(body))),
  getBenefitsLadder: (body)=>(dispatch(getBenefitsLadder(body))),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DifferentialAdvantageContainer));



// WEBPACK FOOTER //
// ./src/containers/DifferentialAdvantage/DifferentialAdvantageContainer.jsx